import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import mailingActions from '../actions/mailingInformation';

// Middleware function
function getMailingMetadata(store) {
    request.get(`/${config.url_prefix}/api/addressMetadata?site=${store.getState().system.siteName}`)
        .end((error, response) => {
            if (error) {
                const errorKey = 'internal.server.error';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(mailingActions.alertError(errorKey));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    if (!parsedResponse || parsedResponse.statusCode >= 400 || parsedResponse.code >= 400) {
                        store.dispatch(mailingActions.alertError('ipmob.error.process.request'));
                        store.dispatch(actions.enableLoadOverLay(false));
                    } else {
                        store.dispatch(mailingActions.getMailingMetadataSuccess(parsedResponse));
                        if (store.getState().billingSetup?.isBillingSetupFlow) {
                            const addressData = store.getState().billingSetup?.userMeta?.contact?.addresses;
                            store.dispatch(mailingActions.prePopulateFromBillingSetupMetadata(addressData));
                        }
                        store.dispatch(actions.enableLoadOverLay(false));
                    }
                } catch (exp) {
                    store.dispatch(mailingActions.alertError('ipmob.error.process.request'));
                    store.dispatch(actions.enableLoadOverLay(false));
                }
            }
        });
}

export default getMailingMetadata;
